// RoleManagementCell.js
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import { ThemedRemoveCircleOutlineIcon } from "assets/CXFIcons/Actions";

const UserRole = ({
  user,
  roles,
  isAllowedAction,
  onOpenConfirmDialog,
  onSetUserToBeRemoved,
}) => {
  const userRoleId = user?.role_id;

  if (userRoleId === undefined || userRoleId === null) {
    return (
      <SoftTypography variant="caption" color="textSecondary">
        No Role
      </SoftTypography>
    );
  }

  const filteredRoles = roles.filter((role) => role.name !== "Owner");
  const selectOptions = filteredRoles.map((role) => ({ label: role.name, value: role.id }));
  const selectedOption = selectOptions.find((opt) => opt.value == userRoleId);

  const handleSelectChange = (selectedRoleOption) => {
    onOpenConfirmDialog(user, selectedRoleOption);
  };

  const handleRemoveClick = () => {
    onSetUserToBeRemoved(user);
  };

  return (
    <SoftBox display="flex" alignItems="center" justifyContent="flex-end">
      <SoftSelect
        className="flow-user-select"
        options={selectOptions}
        value={selectedOption || null}
        onChange={handleSelectChange}
        isDisabled={!isAllowedAction("edit")}
      />
      {isAllowedAction("remove") && (
        <button
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={handleRemoveClick}
        >
          <ThemedRemoveCircleOutlineIcon
            fontSize="medium"
            width="32px"
            height="32px"
            sx={{ cursor: "pointer" }}
          />
        </button>
      )}
    </SoftBox>
  );
};

export default UserRole;
